import { AxiosError } from 'axios';

import { STORAGE_UPLOAD_AVATAR_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export type UploadAvatarResult = {
  file_name: string;
  file_path: string;
  file_url: string;
  file_size: number;
  file_type: string;
  bucket: string;
};

const uploadAvatar = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await apiManager.post<ApiResponse<UploadAvatarResult>>(
      STORAGE_UPLOAD_AVATAR_API_URL,
      formData
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError<ApiResponse<unknown>>;
      const data = error.response?.data;
      const message =
        data?.message ||
        (data?.error && typeof data.error === 'object'
          ? data.error.message
          : null) ||
        'Upload failed';
      return Promise.reject(new Error(message));
    }

    const url = response.data.data?.file_url;
    if (!url || typeof url !== 'string') {
      return Promise.reject(new Error('Invalid upload response'));
    }

    return url;
  } catch (e) {
    return Promise.reject(e);
  }
};

export default uploadAvatar;
